import type { FaireProductEntity } from "../../entity_types/product";

export const p_js8mzmyw98: FaireProductEntity = {
  token: "p_js8mzmyw98",
  type: "product",
  name: "Feel Better De-Stress Ball, French Fries",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl:
    "https://cdn.faire.com/fastly/8c76ec34b2adc101aacfd7e3edccb42d040b26199e5bd027a87fad6c5d5b2d6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e5e78020afb9a6598f3a77a879cf71c8c11334e5cccc9852dbd1afc7ee6d9d4f.jpeg",
    "https://cdn.faire.com/fastly/72be7cbef356dbc92ad082d55ab61a9efb353097b6483ef252d9f2830248568a.jpeg",
    "https://cdn.faire.com/fastly/a766bfe289679bf2447896f5e9c619c11868e3d6937daf800cb3d89d4003455e.jpeg",
  ],
  priceDollars: 5,
  description:
    "Because there’s nothing stressful about French Fries. This ban.do de-stress ball is shaped like a carton of fries and made from slow-rising polyurethane foam, which means no matter how tight you squeeze, it always bounces back to its original shape. Cute, squishy, and totally crave-worthy—this one’s comfort food for your hands.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• French fry–shaped design made of slow-rising polyurethane foam\n• Returns to its original shape after every squeeze\n• Great for stress relief, fidgeting, or mindful breaks\n• Compact and lightweight—perfect for home, office, or travel\n• Designed in ban.do’s signature bright and playful style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and lifestyle boutiques\n• Wellness and novelty retailers\n• Students, professionals, and fidget toy fans\n• Wholesale buyers seeking fun, functional stress-relief accessories",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:46.402Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
